import * as api from "api/Core";
import { GenericLogDialog, GenericLogDialogProps, ILogTranslated } from "components/GenericLogDialog";
import { LogRecord } from "models/ApiModels";
import * as React from 'react';
import { withTranslation } from 'react-i18next';
import { KnowledgeTestImportanceName } from 'views/Dashboards/components/KnowledgeCommons';

///////////////////////////////////////////////////////////////////////////////

interface IProps extends GenericLogDialogProps {
    testId: string;
}

///////////////////////////////////////////////////////////////////////////////

class KnowledgeTestLogDialog extends GenericLogDialog<IProps> {

    getLog(offset: number, take: number) {
        return api.getKnowledgeTestLog(this.props.testId, offset, take);
    }

    translate(data: LogRecord[]): ILogTranslated[] {
        const result: ILogTranslated[] = [];

        data.forEach((v) => {
            var j = v.jsonData;

            Object.keys(j).forEach((key) => {

                const r: ILogTranslated = {
                    name: this.defaultFieldName(key, "KnowledgeTest"),
                    content: "?",
                    creationDate: v.creationDate,
                    creator: v.creator,
                };

                switch (key) {

                    case "Created":
                        r.content = null;
                        break;

                    case "Title":
                        r.content = this.valueFromToTranslate(j[key]["From"], j[key]["To"]);
                        break;

                    case "DifficultyLevel":
                        r.content = this.valueFromToTranslate(j[key]["From"], j[key]["To"]);
                        break;

                    case "Importance":
                        r.content = this.valueFromToTranslate(<KnowledgeTestImportanceName value={j[key]["From"]} />, <KnowledgeTestImportanceName value={j[key]["To"]} />);
                        break;

                    case "ApplyTestStartDate":
                        r.content = this.dateFromToTranslate(j[key]["From"], j[key]["To"]);
                        break;

                    case "ApplyTestEndDate":
                        r.content = this.dateFromToTranslate(j[key]["From"], j[key]["To"]);
                        break;

                    case "AlternativesChanged":
                        r.content = null;
                        break;

                    case "DefaultFeedback":
                        r.content = this.booleanValueTranslate(j[key]);
                        break;

                }
                result.push(r);
            });
        });

        return result;
    }
}
export default withTranslation("log")(KnowledgeTestLogDialog); 